"use client";

import useMobile from "@/hooks/useMobile";
import { ToastType } from "@/types/common";
import { Toast as GlobalToast } from "@monsterindia/global-ui-components";
import React from "react";

type ToastProps = {
  toast: ToastType;
  setToast: React.Dispatch<React.SetStateAction<ToastType>>;
};

const Toast = ({ toast, setToast }: ToastProps) => {
  const isMobile = useMobile();

  return (
    <GlobalToast
      position="top-center"
      showToast={toast.show}
      text={toast.message}
      type={toast.type}
      width={isMobile ? "75" : "25"}
      timer={3000}
      onClose={() =>
        setToast((prev) => ({
          ...prev,
          show: false,
        }))
      }
    />
  );
};

export default Toast;
